const isTouchDevice = !!('ontouchstart' in window || navigator.maxTouchPoints);

export const addIsTouchDeviceClassName = () => {
  document.documentElement.classList.add(isTouchDevice ? 'mn_touch' : 'mn_noTouch');
};

export default isTouchDevice;
